import React from "react";
import { ComplianceScoreGauge } from "./ComplianceScoreGauge";
import { MaturityCard } from "./MaturityCard";
import { PenaltyGauge } from "./PenaltyGauge";
import { SDFCard } from "./SDFCard";
import { GapDonut } from "./GapDonut";

export const ZoneA = ({ data }) => {
  const cs = data.compliance_score || {};
  const mat = data.maturity || {};
  return (
    <section data-testid="zone-a" className="space-y-3">
      <h2 className="text-base md:text-lg font-semibold text-[#008080]">Zone A — Executive Vitals</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4">
        <ComplianceScoreGauge
          score={cs.overall_score}
          rag={cs.readiness_rag}
          band={cs.readiness_band}
          trendDelta={cs.trend_delta_pct}
          trendDirection={cs.trend_direction}
        />
        <MaturityCard level={mat.level} label={mat.label} band={mat.band} penaltyText={mat.penalty_exposure_text} />
        <PenaltyGauge penaltyText={mat.penalty_exposure_text} />
        <SDFCard sdf={data.sdf} />
        <GapDonut gaps={data.gap_summary} assessmentId={data.assessment_id} />
      </div>
    </section>
  );
};
